// /* eslint-disable prettier/prettier */
// import { useEffect, useMemo, useState } from 'react';
// import { useLanguage } from '@/i18n';
// import { toAbsoluteUrl } from '@/utils';
// import { DataGrid, DataGridColumnHeader, DataGridColumnVisibility, DataGridRowSelect, DataGridRowSelectAll, KeenIcon, useDataGrid, Menu, MenuItem, MenuToggle } from '@/components';
// import { toast } from 'sonner';
// import { Input } from '@/components/ui/input';
// import { DropdownCard1 } from '@/partials/dropdowns/general';
// import { MembersData } from '.';
// import { Link } from 'react-router-dom';
// const Members = ({tableTitle, tableData}) => {
//   const {
//     isRTL
//   } = useLanguage();
//   const storageFilterId = 'members-filter';
//   const ColumnInputFilter = ({
//     column
//   }) => {
//     return <Input placeholder="Filter..." value={column.getFilterValue() ?? ''} onChange={event => column.setFilterValue(event.target.value)} className="h-9 w-full max-w-40" />;
//   };
//   const columns = useMemo(() => [{
//     accessorKey: 'id',
//     header: () => <DataGridRowSelectAll />,
//     cell: ({
//       row
//     }) => <DataGridRowSelect row={row} />,
//     enableSorting: false,
//     enableHiding: false,
//     meta: {
//       headerClassName: 'w-0'
//     }
//   }, {
//     accessorFn: row => row.member,
//     id: 'member',
//     header: ({
//       column
//     }) => <DataGridColumnHeader title='Member' filter={<ColumnInputFilter column={column} />} column={column} />,
//     enableSorting: true,
//     cell: info => <div className="flex items-center gap-2.5">
//             <div className="shrink-0">
//               <img src={toAbsoluteUrl(`/media/avatars/${info.row.original.member.avatar}`)} className="h-9 rounded-full" alt="" />
//             </div>
//             <div className="flex flex-col gap-0.5">
//               <a className="leading-none font-medium text-sm text-gray-900 hover:text-primary" href="#">
//                 {info.row.original.member.name}
//               </a>
//               <span className="text-2sm text-gray-700 font-normal">
//                 {info.row.original.member.tasks} tasks
//               </span>
//             </div>
//           </div>,
//     meta: {
//       headerClassName: 'min-w-[250px]'
//     }
//   }, {
//     accessorFn: row => row.location,
//     id: 'location',
//     header: ({
//       column
//     }) => <DataGridColumnHeader title='Location' column={column} />,
//     enableSorting: true,
//     cell: info => <div className="flex items-center gap-1.5">
//             <img src={toAbsoluteUrl(`/media/flags/${info.row.original.location.flag}`)} className="h-4 rounded-full" alt="" />
//             <span className="leading-none text-gray-800 font-normal">
//               {info.row.original.location.name}
//             </span>
//           </div>,
//     meta: {
//       headerClassName: 'min-w-[120px]'
//     }
//   }, {
//     accessorFn: row => row.status,
//     id: 'status',
//     header: ({
//       column
//     }) => <DataGridColumnHeader title='Status' column={column} />,
//     enableSorting: true,
//     cell: info => <span className={`badge badge-pill badge-outline ${info.row.original.status.variant} gap-1 items-center`}>
//             <span className={`badge badge-dot size-1.5 ${info.row.original.status.variant}`}></span>
//             {info.row.original.status.label}
//           </span>,
//     meta: {
//       headerClassName: 'min-w-[120px]'
//     }
//   }, {
//     accessorFn: row => row.recentlyActivity,
//     id: 'recentlyActivity',
//     header: ({
//       column
//     }) => <DataGridColumnHeader title='Recent activity' column={column} />,
//     enableSorting: true,
//     cell: info => info.getValue(),
//     meta: {
//       headerTitle: 'Recent activity',
//       headerClassName: 'min-w-[160px]'
//     }
//   }, {
//     id: 'click',
//     header: () => '',
//     enableSorting: false,
//     cell: () => <Menu className="items-stretch">
//             <MenuItem toggle="dropdown" trigger="click" dropdownProps={{
//         placement: isRTL() ? 'bottom-start' : 'bottom-end',
//         modifiers: [{
//           name: 'offset',
//           options: {
//             offset: isRTL() ? [0, -10] : [0, 10] // [skid, distance]
//           }
//         }]
//       }}>
//               <MenuToggle className="btn btn-sm btn-icon btn-light btn-clear">
//                 <KeenIcon icon="dots-vertical" />
//               </MenuToggle>
//               {DropdownCard1()}
//             </MenuItem>
//           </Menu>,
//     meta: {
//       headerClassName: 'w-[60px]'
//     }
//   }], [isRTL]);

//   // Memoize the team data
//   console.log(tableData);
//   const data = useMemo(() => tableData ? tableData : MembersData, []);

//   // Initialize search term from localStorage if available
//   const [searchTerm, setSearchTerm] = useState(() => {
//     return localStorage.getItem(storageFilterId) || '';
//   });

//   // Update localStorage whenever the search term changes
//   useEffect(() => {
//     localStorage.setItem(storageFilterId, searchTerm);
//   }, [searchTerm]);

//   // Filtered data based on search term
//   const filteredData = useMemo(() => {
//     if (!searchTerm) return data; // If no search term, return full data

//     return data.filter(member => member.member.name.toLowerCase().includes(searchTerm.toLowerCase()) || member.member.tasks.toLowerCase().includes(searchTerm.toLowerCase()));
//   }, [searchTerm, data]);
//   const handleRowSelection = state => {
//     const selectedRowIds = Object.keys(state);
//     if (selectedRowIds.length > 0) {
//       toast(`Total ${selectedRowIds.length} are selected.`, {
//         description: `Selected row IDs: ${selectedRowIds}`,
//         action: {
//           label: 'Undo',
//           onClick: () => console.log('Undo')
//         }
//       });
//     }
//   };
//   const Toolbar = () => {
//     const {
//       table
//     } = useDataGrid();
//     return <div className="card-header px-5 py-5 border-b-0 flex-wrap gap-2">
//         <h3 className="card-title">{tableTitle}</h3>

//         <div className="flex flex-wrap items-center gap-2.5">
//           <div className="relative">
//             <KeenIcon icon="magnifier" className="leading-none text-md text-gray-500 absolute top-1/2 start-0 -translate-y-1/2 ml-3" />
//             <input type="text" placeholder="Search Members" className="input input-sm ps-8" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} // Update search term
//           />
//           </div>
//           <DataGridColumnVisibility table={table} />
//           <label className="switch switch-sm">
//             <input name="check" type="checkbox" value="1" className="order-2" readOnly />
//             <Link to={'/contacts/create'} className='btn btn-xs btn-sm btn-light'>
//               <KeenIcon icon="plus" className="w-fit btn-icon" />
//               Add New
//             </Link>
//             <span className="switch-label order-1">Active Users</span>
//           </label>
//         </div>
//       </div>;
//   };
//   return <DataGrid columns={columns} data={filteredData} rowSelection={true} onRowSelectionChange={handleRowSelection} pagination={{
//     size: 5
//   }} sorting={[{
//     id: 'member',
//     desc: false
//   }]} toolbar={<Toolbar />} layout={{
//     card: true
//   }} />;
// };
// export { Members };

import { useEffect, useMemo, useState } from "react";
import { useLanguage } from "@/i18n";
import { toAbsoluteUrl } from "@/utils";
import {
  DataGrid,
  DataGridColumnHeader,
  DataGridColumnVisibility,
  DataGridRowSelect,
  DataGridRowSelectAll,
  KeenIcon,
  useDataGrid,
  Menu,
  MenuItem,
  MenuToggle,
} from "@/components";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { DropdownCard1 } from "@/partials/dropdowns/general";
import { Link } from "react-router-dom";

// const getNestedValue = (obj, path) => path.split('.').reduce((o, key) => (o ? o[key] : "-"), obj);

// const Members = ({ tableTitle, tableData, tableColumns }) => {
//   const { isRTL } = useLanguage();
//   const storageFilterId = "members-filter";

//   // Column Filter Input
//   const ColumnInputFilter = ({ column }) => (
//     <Input
//       placeholder="Filter..."
//       value={column.getFilterValue() ?? ""}
//       onChange={(event) => column.setFilterValue(event.target.value)}
//       className="h-9 w-full max-w-40"
//     />
//   );

//   // Generate columns dynamically based on props
//   const columns = useMemo(() => {
//     if (!tableColumns || tableColumns.length === 0) return [];

//     const dynamicColumns = tableColumns.map((col) => ({
//       accessorKey: col.accessorKey,
//       id: col.accessorKey,
//       header: ({ column }) => (
//         <DataGridColumnHeader
//           title={col.header}
//           filter={<ColumnInputFilter column={column} />}
//           column={column}
//         />
//       ),
//       enableSorting: col.sortable !== false,
//       cell: (info) => {
//         const value = getNestedValue(info.row.original, col.accessorKey);

//         // Special handling for `assignedTo.avatar` + `assignedTo.name`
//         if (col.accessorKey === "assignedTo") {
//           return (
//             <div className="flex items-center gap-2.5">
//               <div className="shrink-0">
//                 <img src={toAbsoluteUrl(`/media/avatars/${value.avatar}`)} className="h-9 rounded-full" alt="" />
//               </div>
//               <div className="flex flex-col gap-0.5">
//                 <span className="leading-none font-medium text-sm text-gray-900">{value.name}</span>
//               </div>
//             </div>
//           );
//         }

//         return value || "-"; // Default to "-" if value is missing
//       },
//       meta: { headerClassName: col.className || "min-w-[120px]" },
//     }));

//     // Append the action menu column at the end
//     return [
//       {
//         accessorKey: "id",
//         header: () => <DataGridRowSelectAll />,
//         cell: ({ row }) => <DataGridRowSelect row={row} />,
//         enableSorting: false,
//         enableHiding: false,
//         meta: { headerClassName: "w-0" },
//       },
//       ...dynamicColumns,
//       {
//         id: "actions",
//         header: () => "",
//         enableSorting: false,
//         cell: () => (
//           <Menu className="items-stretch">
//             <MenuItem
//               toggle="dropdown"
//               trigger="click"
//               dropdownProps={{
//                 placement: isRTL() ? "bottom-start" : "bottom-end",
//                 modifiers: [{ name: "offset", options: { offset: isRTL() ? [0, -10] : [0, 10] } }],
//               }}
//             >
//               <MenuToggle className="btn btn-sm btn-icon btn-light btn-clear">
//                 <KeenIcon icon="dots-vertical" />
//               </MenuToggle>
//               {DropdownCard1()}
//             </MenuItem>
//           </Menu>
//         ),
//         meta: { headerClassName: "w-[60px]" },
//       },
//     ];
//   }, [tableColumns, isRTL]);

//   const data = useMemo(() => tableData || [], [tableData]);

//   const [searchTerm, setSearchTerm] = useState(() => localStorage.getItem(storageFilterId) || "");

//   useEffect(() => {
//     localStorage.setItem(storageFilterId, searchTerm);
//   }, [searchTerm]);

//   const filteredData = useMemo(() => {
//     if (!searchTerm) return data;
//     return data.filter((row) =>
//       Object.values(row).some((value) =>
//         value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     );
//   }, [searchTerm, data]);

//   const handleRowSelection = (state) => {
//     const selectedRowIds = Object.keys(state);
//     if (selectedRowIds.length > 0) {
//       toast(`Total ${selectedRowIds.length} selected.`, {
//         description: `Selected row IDs: ${selectedRowIds}`,
//         action: { label: "Undo", onClick: () => console.log("Undo") },
//       });
//     }
//   };

//   const Toolbar = () => {
//     const { table } = useDataGrid();
//     return (
//       <div className="card-header px-5 py-5 border-b-0 flex-wrap gap-2">
//         <h3 className="card-title">{tableTitle}</h3>
//         <div className="flex flex-wrap items-center gap-2.5">
//           <div className="relative">
//             <KeenIcon
//               icon="magnifier"
//               className="leading-none text-md text-gray-500 absolute top-1/2 start-0 -translate-y-1/2 ml-3"
//             />
//             <input
//               type="text"
//               placeholder="Search Members"
//               className="input input-sm ps-8"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </div>
//           <DataGridColumnVisibility table={table} />
//           <Link to={"/contacts/create"} className="btn btn-xs btn-sm btn-light">
//             <KeenIcon icon="plus" className="w-fit btn-icon" />
//             Add New
//           </Link>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <DataGrid
//       columns={columns}
//       data={filteredData}
//       rowSelection={true}
//       onRowSelectionChange={handleRowSelection}
//       pagination={{ size: 5 }}
//       sorting={[{ id: "email", desc: false }]}
//       toolbar={<Toolbar />}
//       layout={{ card: true }}
//     />
//   );
// };

// export { Members };
const getNestedValue = (obj, path) => path.split('.').reduce((o, key) => (o ? o[key] : "-"), obj);

const Members = ({ tableTitle, tableData, tableColumns }) => {
  const { isRTL } = useLanguage();
  const storageFilterId = "members-filter";

  const ColumnInputFilter = ({ column }) => (
    <Input
      placeholder="Filter..."
      value={column.getFilterValue() ?? ""}
      onChange={(event) => column.setFilterValue(event.target.value)}
      className="h-9 w-full max-w-40"
    />
  );

  const columns = useMemo(() => {
    if (!tableColumns || tableColumns.length === 0) return [];

    const dynamicColumns = tableColumns.map((col) => ({
      accessorKey: col.accessorKey,
      id: col.accessorKey,
      header: ({ column }) => (
        <DataGridColumnHeader
          title={col.header}
          filter={<ColumnInputFilter column={column} />}
          column={column}
        />
      ),
      enableSorting: col.sortable !== false,
      cell: (info) => {
        const value = getNestedValue(info.row.original, col.accessorKey);

        // Handle "assignedTo"
        if (col.accessorKey === "assignedTo") {
          return (
            <div className="flex items-center gap-2.5">
              <div className="shrink-0">
                <img
                  src={toAbsoluteUrl(`/media/avatars/${value.avatar}`)}
                  className="h-9 rounded-full"
                  alt=""
                />
              </div>
              <div className="flex flex-col gap-0.5">
                <span className="leading-none font-medium text-sm text-gray-900">{value.name}</span>
              </div>
            </div>
          );
        }

        // Handle "status" as a pill
        if (col.accessorKey === "status") {
          const statusColors = {
            active: "badge-success",
            pending: "badge-primary",
            inactive: "badge-danger",
          };

          return (
            // <span className={`px-2 py-1 rounded-full text-xs font-semibold ${statusColors[value] || "bg-gray-300"}`}>
            //   {value}
            // </span>
            <span className={`badge badge-pill badge-outline ${statusColors[value]} gap-1 items-center`}>
            <span className={`badge badge-dot size-1.5 ${statusColors[value]}`}></span>
            {value}
          </span>
            // if (col.accessorKey === "status" && value) {
            //   return (
            //     <span className={`badge badge-pill badge-outline ${value.variant} gap-1 items-center`}>
            //       <span className={`badge badge-dot size-1.5 ${value.variant}`}></span>
            //       {value.label}
            //     </span>
            //   );
            // }
          );
        }

        return value || "-";
      },
      meta: { headerClassName: col.className || "min-w-[120px]" },
    }));

    return [
      {
        accessorKey: "id",
        header: () => <DataGridRowSelectAll />,
        cell: ({ row }) => <DataGridRowSelect row={row} />,
        enableSorting: false,
        enableHiding: false,
        meta: { headerClassName: "w-0" },
      },
      {
        accessorKey: "fullName",
        header: "Full Name",
        enableSorting: true,
        cell: (info) => {
          const { firstName, lastName } = info.row.original;
          return <Link to={`/contacts/${info.row.original.id}`} className="text-primary">{firstName} {lastName}</Link>;
        },
        meta: { headerClassName: "min-w-[160px]" },
      },
      ...dynamicColumns,
      {
        id: "actions",
        header: () => "",
        enableSorting: false,
        cell: () => (
          <Menu className="items-stretch">
            <MenuItem
              toggle="dropdown"
              trigger="click"
              dropdownProps={{
                placement: isRTL() ? "bottom-start" : "bottom-end",
                modifiers: [{ name: "offset", options: { offset: isRTL() ? [0, -10] : [0, 10] } }],
              }}
            >
              <MenuToggle className="btn btn-sm btn-icon btn-light btn-clear">
                <KeenIcon icon="dots-vertical" />
              </MenuToggle>
              {DropdownCard1()}
            </MenuItem>
          </Menu>
        ),
        meta: { headerClassName: "w-[60px]" },
      },
    ];
  }, [tableColumns, isRTL]);

  const data = useMemo(() => tableData || [], [tableData]);

  const [searchTerm, setSearchTerm] = useState(() => localStorage.getItem(storageFilterId) || "");

  useEffect(() => {
    localStorage.setItem(storageFilterId, searchTerm);
  }, [searchTerm]);

  const filteredData = useMemo(() => {
    if (!searchTerm) return data;
    return data.filter((row) =>
      Object.values(row).some((value) =>
        value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, data]);

  const handleRowSelection = (state) => {
    const selectedRowIds = Object.keys(state);
    if (selectedRowIds.length > 0) {
      toast(`Total ${selectedRowIds.length} selected.`, {
        description: `Selected row IDs: ${selectedRowIds}`,
        action: { label: "Undo", onClick: () => console.log("Undo") },
      });
    }
  };

  const Toolbar = () => {
    const { table } = useDataGrid();
    return (
      <div className="card-header px-5 py-5 border-b-0 flex-wrap gap-2">
        <h3 className="card-title">{tableTitle}</h3>
        <div className="flex flex-wrap items-center gap-2.5">
          <div className="relative">
            <KeenIcon
              icon="magnifier"
              className="leading-none text-md text-gray-500 absolute top-1/2 start-0 -translate-y-1/2 ml-3"
            />
            <input
              type="text"
              placeholder="Search Members"
              className="input input-sm ps-8"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <DataGridColumnVisibility table={table} />
          <Link to={"/contacts/create"} className="btn btn-xs btn-sm btn-light">
            <KeenIcon icon="plus" className="w-fit btn-icon" />
            Add New
          </Link>
        </div>
      </div>
    );
  };

  return (
    <DataGrid
      columns={columns}
      data={filteredData}
      rowSelection={true}
      onRowSelectionChange={handleRowSelection}
      pagination={{ size: 5 }}
      sorting={[{ id: "email", desc: false }]}
      toolbar={<Toolbar />}
      layout={{ card: true }}
    />
  );
};

export { Members };






// import { useEffect, useMemo, useState } from "react";
// import { DataGrid, DataGridColumnHeader, DataGridRowSelect, DataGridRowSelectAll, DataGridColumnVisibility, useDataGrid, KeenIcon } from "@/components";
// import { Input } from "@/components/ui/input";
// import { toast } from "sonner";
// import { Link } from "react-router-dom";

// const Members = ({ tableTitle = "Table", tableData = [], tableColumns }) => {

//   const allColumns = useMemo(() => {
//     if (!tableData.length) return [];
//     return Object.keys(tableData[0]).filter((key) => key !== "MiddleName"); // Ignore MiddleName
//   }, [tableData]);

//   // ✅ Ensure the state initializes from props
//   const [visibleColumns, setVisibleColumns] = useState(new Set(tableColumns?.length ? tableColumns : allColumns));

//   useEffect(() => {
//     setVisibleColumns(new Set(tableColumns?.length ? tableColumns : allColumns));
//   }, [tableColumns]);

//   // ✅ Toggle column visibility dynamically
//   const toggleColumn = (column) => {
//     setVisibleColumns((prev) => {
//       const newSet = new Set(prev);
//       newSet.has(column) ? newSet.delete(column) : newSet.add(column);
//       return newSet;
//     });
//   };

//   const columns = useMemo(() => {
//     let baseColumns = [
//       {
//         accessorKey: "id",
//         header: () => <DataGridRowSelectAll />,
//         cell: ({ row }) => <DataGridRowSelect row={row} />,
//         enableSorting: false,
//         enableHiding: false,
//         meta: { headerClassName: "w-0" },
//       },
//       {
//         id: "fullName",
//         header: ({ column }) => (
//           <DataGridColumnHeader
//             title="Full Name"
//             filter={<ColumnInputFilter column={column} />}
//             column={column}
//           />
//         ),
//         enableSorting: true,
//         cell: (info) => {
//           const { firstName, LastName } = info.row.original;
//           return <Link to={`/contacts/${info.row.original.id}`} className="text-blue-600 hover:underline">
//             {firstName} {LastName}
//           </Link>
//         },
//         meta: { headerClassName: "min-w-[180px]" },
//       },
//     ];

//     // ✅ Add visible columns dynamically
//     baseColumns.push(
//       ...allColumns
//         .filter((key) => key !== "firstName" && key !== "LastName" && visibleColumns.has(key))
//         .map((key) => ({
//           accessorKey: key,
//           id: key,
//           header: ({ column }) => (
//             <DataGridColumnHeader
//               title={key.replace(/([A-Z])/g, " $1")}
//               filter={<ColumnInputFilter column={column} />}
//               column={column}
//             />
//           ),
//           enableSorting: true,
//           cell: (info) => {
//             const value = info.getValue();
//             if (key === "email") return <a href={`mailto:${value}`} className="text-primary">{value}</a>;
//             if (key === "website") return <a href={value} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">{value}</a>;
//             if (typeof value === "object" && value !== null) return JSON.stringify(value);
//             return <span className="text-gray-800">{value ?? "—"}</span>;
//           },
//           meta: { headerClassName: "min-w-[150px]" },
//         }))
//     );

//     return baseColumns;
//   }, [visibleColumns, allColumns]);

//   const Toolbar = () => {
//     const { table } = useDataGrid();
//     return (
//       // <div className="card-header px-5 py-5 border-b-0 flex-wrap gap-2">
//       //   <h3 className="card-title">{tableTitle}</h3>
//       //   <div className="flex flex-wrap items-center gap-2.5">
//       //     <DataGridColumnVisibility table={table} defaultColumns={Array.from(visibleColumns)} />
//       //   </div>
//       // </div>
//       <div className="card-header px-5 py-5 border-b-0 flex-wrap gap-2">
//         <h3 className="card-title">{tableTitle}</h3>
//         <div className="flex flex-wrap items-center gap-2.5">
//           {/* Search Input */}
//           <div className="relative">
//             <KeenIcon
//               icon="magnifier"
//               className="leading-none text-md text-gray-500 absolute top-1/2 start-0 -translate-y-1/2 ml-3"
//             />
//             <Input
//               type="text"
//               placeholder="Search..."
//               className="input input-sm ps-8"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </div>

//           {/* Column Visibility Toggle */}
//           <DataGridColumnVisibility table={table} />

//           {/* Actions Menu */}
//           <label className="switch switch-sm">
//             <input name="check" type="checkbox" value="1" className="order-2" readOnly />
//             <Link to={"/contacts/create"} className="btn btn-xs btn-sm btn-light">
//               <KeenIcon icon="plus" className="w-fit btn-icon" /> Add New
//             </Link>
//             <span className="switch-label order-1">Active Users</span>
//           </label>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <DataGrid
//       columns={columns}
//       data={tableData}
//       rowSelection={true}
//       pagination={{ size: 5 }}
//       toolbar={<Toolbar />}
//       layout={{ card: true }}
//     />
//   );
// };


// // ✅ Input Filter Component
// const ColumnInputFilter = ({ column }) => (
//   <Input
//     placeholder="Filter..."
//     value={column.getFilterValue() ?? ""}
//     onChange={(event) => column.setFilterValue(event.target.value)}
//     className="h-9 w-full max-w-40"
//   />
// );

// export { Members };